import React from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { BigNumber } from 'bignumber.js'

// utils
import { DISHESDICT } from '../../constants/bakery/nft'
import { BIGNUMBER_FMT } from '../../constants/bakery'

// components
import Modal from '../Modal'
import PlateCard from './PlateCard'
import Value from '../../components/Value/OnlyValue'
import FoodsList from '../../components/restaurant/FoodsList'

// hooks
import useBlock from '../../hooks/bakery/useBlock'
import useRoi from '../../hooks/nft/useRoi'

interface DishesPreviewModalProps {
  isOpen: boolean
  onDismiss: () => void
  dish: any
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.bsBg6};
  width: 355px;
  padding: 24px 16px 16px;
`
const ModalTitle = styled.div`
  color: ${({ theme }) => theme.primary1};
  font-family: Baloo Da;
  text-align: center;
  margin-bottom: 3rem;
`
const DishesTitle = styled.div`
  padding: 16px 16px 0;
`
const AttachWrapper = styled.div`
  margin-top: 16px;
`
const AttachRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`
const ValueItem = styled.div`
  display: flex;
  align-items: center;
`
const BakeText = styled.div`
  margin-left: 5px;
`
const ButtonGroup = styled.div`
  padding-bottom: 24px;
`
const MyDishes = styled(NavLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.primary1};
  border-radius: 10px;
  color: ${({ theme }) => theme.bsText1};
  font-family: Baloo Da;
  width: 290px;
  height: 40px;
  text-decoration: none;
  margin: 24px auto 0;
`
const Twitter = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.primary1};
  border-radius: 10px;
  color: ${({ theme }) => theme.primary1};
  width: 290px;
  height: 40px;
  margin: 6px auto 0;
  text-decoration: none;
`

export default function DishesPreviewModal({ isOpen, onDismiss, dish }: DishesPreviewModalProps) {
  const currentBlock = useBlock()
  const roi = useRoi(currentBlock, dish ? dish.stakingPowerMultiple : 0)
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90} minHeight={40} maxWidth={355}>
      <Wrapper>
        <ModalTitle>
          <Text fontSize={20} lineHeight={1}>
            Congratulations!
          </Text>
          <Text fontSize={20} lineHeight={1}>
            You got a new combo!
          </Text>
        </ModalTitle>
        <PlateCard
          iconUrl={(process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/' + (dish ? dish.dishIcon : '000000.svg')}
          level={dish ? dish.level + 1 : undefined}
        >
          <DishesTitle>
            <Text fontSize={22}>{dish ? DISHESDICT[dish.level] : DISHESDICT[0]}</Text>
          </DishesTitle>
          <FoodsList items={dish ? dish.items : []}></FoodsList>
          <AttachWrapper>
            <AttachRow>
              <Text fontSize={14}>Decompose to get:</Text>
              <ValueItem>
                <Value decimals={0} value={(dish && dish.bakeAmount) ? +dish.bakeAmount : '***'} />
                <BakeText>BAKE</BakeText>
              </ValueItem>
            </AttachRow>
            <AttachRow>
              <Text fontSize={14}>Staking Power:</Text>
              <Text>
                <Value decimals={0} value={(dish && dish.stakingPowerAmount) ? +dish.stakingPowerAmount : '***'} />
              </Text>
            </AttachRow>
            <AttachRow>
              <Text fontSize={14}>ROI:</Text>
              <Text>
                <Value
                  decimals={0}
                  value={
                    roi && !roi.isNaN() && roi.gt(0)
                      ? roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%'
                      : '-'
                  }
                />
              </Text>
            </AttachRow>
          </AttachWrapper>
          <ButtonGroup>
            <MyDishes to={'/my-combos'}>My Combos</MyDishes>
            {null && (
              <Twitter
                href={
                  'http://twitter.com/share?url=' +
                  encodeURIComponent('https://bsc.bakeryswap.org/#/nft') +
                  '&text=' +
                  encodeURIComponent('Come to BakerySwap Make your combo!')
                }
                target="_blank"
              >
                <img src={'/images/nft/icon_twitter.svg'} alt="twitter" />
                <Text>Share on Twitter</Text>
              </Twitter>
            )}
          </ButtonGroup>
        </PlateCard>
      </Wrapper>
    </Modal>
  )
}
